// extracted by mini-css-extract-plugin
export default {"modalContainer":"ConfirmationModal_modalContainer__dwoGk","modTitle":"ConfirmationModal_modTitle__+jvMv"};